import { useBrand } from '../context/BrandContext';
import FastestFormResetPassword from './fastestform/ResetPassword';
import AbleResetPassword from './able/ResetPassword';

export default function ResetPassword() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleResetPassword /> : <FastestFormResetPassword />;
}
